import apiService from '../Api'
import { TerminalPaymentsResponse } from './types'

export type TerminalPaymentsParams = {
  status?: 'approved' | 'voided' | 'all'
  method?: string
  machine_id?: number
  search?: string
  page?: number
  page_size?: number
}

export class EventTerminalPaymentsService {
  async list(eventId: number, params: TerminalPaymentsParams): Promise<TerminalPaymentsResponse> {
    return apiService.get(`/events/${eventId}/terminal-payments`, { params }).then((res) => res.data)
  }
}
